// extracted by mini-css-extract-plugin
export default {"slot":"Slot_slot__Wx97g","time-options":"Slot_time-options__BjdxD","separator":"Slot_separator__yZwUJ","time-slot-actions":"Slot_time-slot-actions__7wIEi"};